<template>
  <div>
    <el-dialog
      :visible.sync="addServiceDialog"
      width="50%"
      title="份额认领"
      :close-on-click-modal="false"
    >
    <el-form :inline="true" >
        <el-form-item label="投资人电话">
            <el-input v-model="query.phone" placeholder="电话"></el-input>
        </el-form-item>
        <el-form-item>
            <el-button  type="primary" @click="getList(1)">搜索</el-button>
        </el-form-item>
    </el-form>
   
    <auto-table
      :DataList="DataList"
      :option="Option"
      :total="Total"
      @changePage="getList"
    >
      <template #handle="{ row }">
        <el-button size="small" type="success" @click="changeInvest(row)"
          >选择</el-button
        >
      </template>
    </auto-table>
    
      <el-form :model="form" label-width="auto" :rules="rules" ref="courseForm">
        <el-form-item label="认购投资人">
          {{invest.name || '请选择投资人'}}
        </el-form-item>
        <el-form-item label="认购份额" prop="shares">
          <el-input
          type="number"
            v-model="form.shares"
            placeholder="认购份额"
          >
           <template slot="append">份</template>
          </el-input>
        </el-form-item>
        <el-form-item label="认购总价" prop="amount">
          <el-input
            v-model="form.amount"
            placeholder="认购总价"
          > <template slot="append">元</template></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addServiceDialog = false">取 消</el-button>
        <el-button type="primary" @click="submitForm()">添 加</el-button>
      </span>
    </el-dialog>
  </div>
</template>
  
  <script>
import { rules } from "./addRule";
import { ObjectChangedValue } from "@/js/utils";
export default {
  data() {
    return {
      DataList: [],
     query:{
       name:'',
      type:'',
     },
      type: {
        device_invest:'设备投资人'
      },
      Option: [
        { name: "名称", value: "title" },
        { name: "联系人", value: "name" },
        { name: "联系电话", value: "phone" },
        { name: "操作", value: "handle", type: "custom" },
      ],
      Total: 0,
      form: {},
      temp: {},
      rules: rules,
      addServiceDialog: false,
      invest:{},
      managerInfo: JSON.parse(localStorage.getItem("managerInfo")),
      package_id: "",
    };
  },

  mounted() {
    this.package_id = this.$route.query.id;
  },

  methods: {
    changeInvest(v){
      this.invest = v;
    },
    //列表
    getList(v) {
      let page = v || 1;
      this.$axios({
        url: "/user/cooperator/queryManagerListPage",
        params: {
          currentPage: page,
          pageSize: 10,
          phone:this.query.phone || null,
          status: 0,
          types:'device_invest',
        },
      }).then((res) => {
        this.DataList = res.data.data.rows;
        this.Total = res.data.data.total;
      });
    },
    open() {
      this.form = {}
      this.addServiceDialog = true;
    },
    submitForm() {
      this.$refs.courseForm.validate((valid) => {
        if (valid) {
          this.addNew();
        }
      });
    },
    addNew() {
      let url = "/user/investPackageUnion/shareSubscription";
      this.form.handler_id = this.managerInfo.id;
      this.form.handler_name = this.managerInfo.name;
      this.form.investor_id = this.invest.id;
      this.form.package_id = this.package_id;

      this.$axios.post(url, this.form).then((res) => {
        if (res.data.code == 0) {
          this.$message({ type: "warning", message: "添加成功!" });
          this.addServiceDialog = false;
          this.form = {};
          this.$emit("success");
        } else {
          this.$message({ type: "error", message: res.data.message });
        }
      });
    }
  },
};
</script>
  
  <style lang="scss" scoped>
</style>